import React, { useEffect, useState } from "react";
import styled from "@emotion/styled/macro";
import sample from "lodash/sample";
import random from "lodash/random";
import mq from "../utils/mediaQueries";

const Wrapper = styled.div`
  width: 100%;
  position: relative;
`;

const Body1 = styled.polygon`
  fill: ${({ theme }) => theme.header};
`;

const Body2 = styled.rect`
  fill: ${({ theme }) => theme.header};
`;

const Mouth = styled.polygon`
  fill: ${({ theme }) => theme.header};
`;

const ChatBubble = styled.div`
  position: absolute;
  background-color: ${({ theme }) => theme.white};
  padding: 0.5rem;
  right: 110px;
  bottom: 120px;
  width: 175px;

  ${mq("sm")} {
    width: auto;
    white-space: nowrap;
  }

  :before {
    transform: scale(-1, 1);

    content: "";
    width: 0;
    height: 0;
    position: absolute;
    border-left: 24px solid #fff;
    border-right: 12px solid transparent;
    border-top: 12px solid #fff;
    border-bottom: 20px solid transparent;
    right: 0;
    bottom: -24px;
  }
`;

const ChatBubbleText = styled.div`
  user-select: none;
  color: ${({ theme }) => theme.black};
`;

const Eyes = styled.path`
  fill: ${({ theme }) => theme.header};
`;

const StyledDeathy = styled.svg`
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`;

const lines = [
  "Let's explore!",
  "You're wonderful!",
  "Today is your day.",
  "Remember: you are valuable!",
  "You're the best!",
  "I want to be like you.",
  "We're very proud of you.",
  "You're strong!",
  "My goodness, you're incredible!",
  "Time to roll out!",
  "You still got it!",
  "This will be an excellent day!",
  "You're amazing!",
  "I believe in you!",
  "Have a nice death in space!",
  "Thanks for being you!",
  "You're so savvy!",
  "You're my favorite!",
  "You have the best ideas.",
  "You have a good heart!",
  "You can do anything!",
  "Don’t believe in the void!",
  "You will make a difference.",
  "Nice dexterity!",
  "I like your name.",
  "Will you visit the Iron Ring for me?",
  "I'm trying to be like you.",
  "Can we be friends?",
  "We should be a team!",
  "I really appreciate you!",
  "You are special!",
  "I'm your secret admirer.",
  "You are my star.",
  "Be careful.",
  "I’m not watching you.",
  "Shine bright, live forever.",
  "My name is Deathy.",
  "D E A T H Y.",
  "Yup, you've got it!",
  "You are pretty, oh so pretty.",
  "You complete me.",
  "You sparkle like a gem.",
  "Good morning, starshine!",
  "The stars shine on you.",
  "Stay safe!",
  "First time in Tenebris?",
  "Click me, I have more to say.",
  "Jag talar svenska.",
  "Thank you for installing me!",
  "I'm here to stay.",
  "Please visit me again soon!",
  "Can I join your crew?",
];

const Deathy = () => {
  const [speak, setSpeak] = useState("Welcome, my name is Deathy! (v1.1)");

  useEffect(() => {
    const hideTimer = setTimeout(() => {
      setSpeak(() => "");
    }, random(3000, 4000));

    return () => {
      clearTimeout(hideTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [speak]);

  return (
    <Wrapper>
      {speak && (
        <ChatBubble>
          <ChatBubbleText>{speak}</ChatBubbleText>
        </ChatBubble>
      )}
      <StyledDeathy
        onClick={() =>
          setSpeak(() => sample(lines.filter((line) => speak !== line)))
        }
        id="Deathy"
        data-name="Deathy"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 20 80 90"
      >
        <Eyes
          d="M27.88,61.52h1v1h3v-3h2v-7h-2v-3h-7v10h3Zm1-8h3v5h-3Z"
          transform="translate(-4.85 -4.27)"
        />
        <Eyes
          d="M55.88,49.52h-7v10h3v2h1v1h3v-3h2v-7h-2Zm0,9h-3v-5h3Z"
          transform="translate(-4.85 -4.27)"
        />
        <Body2 x="23.03" y="60.25" width="3.93" height="44.99" />
        <Mouth points="33.03 93.25 37.03 93.25 37.03 87.25 44.03 87.25 44.03 79.25 44.03 68.25 48.03 68.25 48.03 61.25 47.03 61.25 47.03 60.25 45.03 60.25 45.03 61.25 44.03 61.25 44.03 67.25 41.03 67.25 41.03 79.25 37.03 79.25 33.96 79.25 33.96 68.25 35.03 68.25 35.03 67.25 36.03 67.25 36.03 61.25 35.03 61.25 35.03 60.25 33.51 60.25 33.51 67.25 30.03 67.25 30.03 87.25 33.03 87.25 33.03 93.25" />
        <Body1 points="48.03 92.25 44.03 92.25 44.03 98.25 41.03 98.25 41.03 104.25 27.03 104.25 27.03 112.25 41.03 112.25 44.03 112.25 44.03 105.25 48.03 105.25 48.03 99.25 51.03 99.25 51.03 79.25 48.03 79.25 48.03 92.25" />
        <Body2 x="14.03" y="29.25" width="2" height="8" />
        <Body2 x="18.03" y="29.25" width="1" height="8" />
        <Body2 x="21.03" y="29.25" width="1" height="8" />
        <Body2 x="25.03" y="29.25" width="1" height="10" />
        <Body2 x="28.03" y="37.25" width="1" height="4" />
        <Body1 points="34.03 29.25 30.03 29.25 30.03 36.25 31.03 36.25 31.03 37.25 37.03 37.25 37.03 36.25 37.03 35.25 37.03 30.25 51.03 30.25 51.03 36.25 54.03 36.25 54.03 30.25 54.03 23.25 34.03 23.25 34.03 29.25" />
        <Body2 x="63.03" y="29.25" width="1" height="8" />
        <Body2 x="59.03" y="36.25" width="1" height="4" />
        <Body2 x="56.03" y="36.25" width="1" height="4" />
        <Body2 x="52.03" y="38.25" width="1" height="3" />
        <Body1 points="49.03 37.25 49.03 41.25 49.03 42.25 48.03 42.25 48.03 43.25 50.03 43.25 50.03 42.25 51.03 42.25 51.03 41.25 50.03 41.25 50.03 37.25 49.03 37.25" />
      </StyledDeathy>
    </Wrapper>
  );
};

export default Deathy;
